import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showBlockMsgModal, setShowBlockMsgModal] = useState(false);
  const [newUser, setNewUser] = useState({ username: '', password: '' });
  const [blockedMessage, setBlockedMessage] = useState('');
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem('zaptime_user') || '{}');

  useEffect(() => {
    const storedUser = localStorage.getItem('zaptime_user');
    if (storedUser) setUser(JSON.parse(storedUser));
    if (currentUser.username !== 'admin') { navigate('/'); return; }
    loadUsers();
    loadBlockedMessage();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/auth/users', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}` }
      });
      const data = await response.json();
      if (data.success) setUsers(data.users);
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadBlockedMessage = async () => {
    try {
      const response = await fetch('/api/admin/blocked-message', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}` }
      });
      const data = await response.json();
      if (data.success) setBlockedMessage(data.blockedMessage);
    } catch(e) {}
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setError('');
    if (!newUser.username || !newUser.password) { setError('Preencha todos os campos'); return; }
    if (newUser.password.length < 6) { setError('A senha deve ter pelo menos 6 caracteres'); return; }

    try {
      const response = await fetch('/api/auth/create-user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}`
        },
        body: JSON.stringify(newUser)
      });
      const data = await response.json();
      if (data.success) {
        alert('Usuário criado com sucesso!');
        setShowModal(false);
        setNewUser({ username: '', password: '' });
        loadUsers();
      } else {
        setError(data.message || 'Erro ao criar usuário');
      }
    } catch (error) {
      setError('Erro ao conectar com o servidor');
    }
  };

  const handleDeleteUser = async (userId) => {
    if (userId === 1) { alert('Não é possível deletar o admin'); return; }
    if (!window.confirm('Tem certeza que deseja deletar este usuário?')) return;

    try {
      const response = await fetch(`/api/auth/delete-user/${userId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}` }
      });
      const data = await response.json();
      if (data.success) { alert('Usuário deletado!'); loadUsers(); }
      else alert(data.message || 'Erro ao deletar');
    } catch (error) {
      alert('Erro ao conectar com o servidor');
    }
  };

  const handleToggleBlock = async (userId, currentlyBlocked) => {
    if (userId === 1) { alert('Não é possível bloquear o admin'); return; }
    const action = currentlyBlocked ? 'desbloquear' : 'bloquear';
    if (!window.confirm(`Deseja ${action} este usuário?`)) return;

    try {
      if (!currentlyBlocked) {
        // Bloquear E desconectar
        const response = await fetch(`/api/admin/block-and-disconnect/${userId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}`,
            'x-user-id': '1'
          }
        });
        const data = await response.json();
        if (data.success) { alert('Usuário bloqueado e desconectado!'); loadUsers(); }
        else alert(data.error || 'Erro ao bloquear');
      } else {
        // Desbloquear
        const response = await fetch(`/api/admin/block-user/${userId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}`
          },
          body: JSON.stringify({ blocked: false })
        });
        const data = await response.json();
        if (data.success) { alert('Usuário desbloqueado!'); loadUsers(); }
        else alert(data.message || 'Erro ao desbloquear');
      }
    } catch (error) {
      alert('Erro ao conectar com o servidor');
    }
  };

  const handleSaveBlockedMessage = async () => {
    try {
      const response = await fetch('/api/admin/blocked-message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('zaptime_token')}`
        },
        body: JSON.stringify({ blockedMessage })
      });
      const data = await response.json();
      if (data.success) {
        alert('Mensagem de bloqueio atualizada!');
        setShowBlockMsgModal(false);
      } else alert(data.message || 'Erro');
    } catch(e) {
      alert('Erro ao salvar mensagem');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('zaptime_user');
    localStorage.removeItem('zaptime_token');
    navigate('/login');
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr).toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric'
      });
    } catch(e) { return '—'; }
  };

  const formatPhone = (number) => {
    if (!number) return '—';
    // Formato: +55 (13) 98183-8910
    if (number.length === 13) {
      return `+${number.slice(0,2)} (${number.slice(2,4)}) ${number.slice(4,9)}-${number.slice(9)}`;
    }
    if (number.length === 12) {
      return `+${number.slice(0,2)} (${number.slice(2,4)}) ${number.slice(4,8)}-${number.slice(8)}`;
    }
    return number;
  };

  if (currentUser.username !== 'admin') return null;
  if (loading) return <div style={styles.loading}>Carregando usuários...</div>;

  const isAdmin = user?.username === 'admin';

  return (
    <div style={styles.container}>
      {/* HEADER */}
      <header style={styles.header}>
        <h1 style={styles.title}>🚀 ZappExpress</h1>
        <div style={styles.userInfo}>
          <span style={styles.userName}>
            👤 {user?.username}
            {isAdmin && <span style={styles.adminBadge}>ADMIN</span>}
          </span>
          <button onClick={handleLogout} style={styles.logoutBtn}>Sair</button>
        </div>
      </header>

      {/* MENU */}
      <nav style={styles.nav}>
        <Link to="/" style={styles.navLink}>🏠 Dashboard</Link>
        <Link to="/flows" style={styles.navLink}>📋 Meus Fluxos</Link>
        <Link to="/users" style={{...styles.navLink, ...styles.navLinkActive}}>👥 Usuários</Link>
      </nav>

      {/* CONTEÚDO */}
      <div style={styles.content}>
        <div style={styles.pageHeader}>
          <h2>👥 Gerenciar Usuários ({users.length})</h2>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={() => setShowBlockMsgModal(true)} style={styles.msgButton}>
              ✉️ Mensagem de Bloqueio
            </button>
            <button onClick={() => setShowModal(true)} style={styles.createButton}>
              + Novo Usuário
            </button>
          </div>
        </div>

        <div style={styles.usersList}>
          {users.map(u => (
            <div key={u.id} style={{
              ...styles.userCard,
              ...(u.blocked ? styles.userCardBlocked : {})
            }}>
              <div style={styles.userInfo2}>
                <div style={styles.userName2}>
                  👤 {u.username}
                  {u.id === 1 && <span style={styles.adminBadge2}>ADMIN</span>}
                  {u.blocked && <span style={styles.blockedBadge}>🚫 BLOQUEADO</span>}
                </div>
                <div style={styles.userDetails}>
                  <span>ID: {u.id}</span>
                  <span>📱 {formatPhone(u.whatsappNumber)}</span>
                  <span>📅 {formatDate(u.createdAt)}</span>
                </div>
              </div>
              {u.id !== 1 && (
                <div style={styles.actionButtons}>
                  <button
                    onClick={() => handleToggleBlock(u.id, u.blocked)}
                    style={u.blocked ? styles.unblockButton : styles.blockButton}
                  >
                    {u.blocked ? '✅ Desbloquear' : '🚫 Bloquear'}
                  </button>
                  <button
                    onClick={() => handleDeleteUser(u.id)}
                    style={styles.deleteButton}
                  >
                    🗑️ Deletar
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Modal: Criar Usuário */}
        {showModal && (
          <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
              <h3 style={styles.modalTitle}>Criar Novo Usuário</h3>
              <form onSubmit={handleCreateUser} style={styles.form}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Usuário:</label>
                  <input type="text" value={newUser.username}
                    onChange={(e) => setNewUser({...newUser, username: e.target.value})}
                    style={styles.input} placeholder="Nome do usuário" required />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Senha:</label>
                  <input type="password" value={newUser.password}
                    onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                    style={styles.input} placeholder="Senha (mínimo 6 caracteres)" required minLength="6" />
                </div>
                {error && <div style={styles.error}>⚠️ {error}</div>}
                <div style={styles.modalActions}>
                  <button type="submit" style={styles.saveButton}>✅ Criar Usuário</button>
                  <button type="button" onClick={() => { setShowModal(false); setNewUser({ username: '', password: '' }); setError(''); }}
                    style={styles.cancelButton}>❌ Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Modal: Mensagem de Bloqueio */}
        {showBlockMsgModal && (
          <div style={styles.modalOverlay} onClick={() => setShowBlockMsgModal(false)}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
              <h3 style={styles.modalTitle}>✉️ Mensagem de Bloqueio</h3>
              <p style={{ color: '#999', fontSize: '14px', marginBottom: '15px' }}>
                Esta mensagem será exibida quando um usuário bloqueado tentar acessar o sistema.
              </p>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Mensagem:</label>
                <textarea value={blockedMessage}
                  onChange={(e) => setBlockedMessage(e.target.value)}
                  style={{...styles.input, minHeight: '100px', resize: 'vertical'}}
                  placeholder="Ex: Acesso negado. Entre em contato com o suporte..."
                />
              </div>
              <div style={styles.modalActions}>
                <button onClick={handleSaveBlockedMessage} style={styles.saveButton}>💾 Salvar</button>
                <button onClick={() => setShowBlockMsgModal(false)} style={styles.cancelButton}>❌ Cancelar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#1a1a1a' },
  header: {
    backgroundColor: '#2c3e50', color: 'white', padding: '20px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },
  title: { margin: 0, fontSize: '24px' },
  userInfo: { display: 'flex', alignItems: 'center', gap: '15px' },
  userName: { fontSize: '16px', display: 'flex', alignItems: 'center', gap: '10px' },
  adminBadge: {
    backgroundColor: '#3498db', padding: '4px 12px', borderRadius: '12px',
    fontSize: '12px', fontWeight: 'bold'
  },
  logoutBtn: {
    padding: '8px 16px', backgroundColor: '#e74c3c', color: 'white',
    border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold'
  },
  nav: { backgroundColor: '#34495e', padding: '15px 20px', display: 'flex', gap: '20px' },
  navLink: {
    color: 'white', textDecoration: 'none', fontSize: '16px',
    padding: '8px 16px', borderRadius: '4px'
  },
  navLinkActive: { backgroundColor: 'rgba(255,255,255,0.1)' },
  content: { padding: '30px', maxWidth: '1200px', margin: '0 auto' },
  pageHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: '30px', color: '#fff', flexWrap: 'wrap', gap: '10px'
  },
  createButton: {
    padding: '12px 24px', backgroundColor: '#28a745', color: 'white',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold'
  },
  msgButton: {
    padding: '12px 24px', backgroundColor: '#6c757d', color: 'white',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold'
  },
  loading: {
    textAlign: 'center', padding: '40px', fontSize: '18px', color: '#ccc',
    backgroundColor: '#1a1a1a', minHeight: '100vh'
  },
  usersList: { display: 'flex', flexDirection: 'column', gap: '15px' },
  userCard: {
    backgroundColor: '#2a2a2a', border: '1px solid #444', padding: '20px',
    borderRadius: '8px', display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.3)', flexWrap: 'wrap', gap: '10px'
  },
  userCardBlocked: {
    borderColor: '#dc3545', backgroundColor: '#2a1a1a', opacity: 0.85
  },
  userInfo2: { flex: 1, minWidth: '250px' },
  userName2: {
    fontSize: '18px', fontWeight: 'bold', color: '#fff', marginBottom: '8px',
    display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'
  },
  adminBadge2: {
    backgroundColor: '#3498db', color: 'white', padding: '4px 12px',
    borderRadius: '12px', fontSize: '12px', fontWeight: 'bold'
  },
  blockedBadge: {
    backgroundColor: '#dc3545', color: 'white', padding: '4px 12px',
    borderRadius: '12px', fontSize: '12px', fontWeight: 'bold'
  },
  userDetails: {
    fontSize: '13px', color: '#999', display: 'flex', gap: '20px', flexWrap: 'wrap'
  },
  actionButtons: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
  blockButton: {
    padding: '10px 18px', backgroundColor: '#e67e22', color: 'white',
    border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold'
  },
  unblockButton: {
    padding: '10px 18px', backgroundColor: '#27ae60', color: 'white',
    border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold'
  },
  deleteButton: {
    padding: '10px 18px', backgroundColor: '#dc3545', color: 'white',
    border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold'
  },
  modalOverlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 1000
  },
  modal: {
    backgroundColor: '#2a2a2a', border: '1px solid #444', padding: '30px',
    borderRadius: '12px', maxWidth: '500px', width: '90%'
  },
  modalTitle: { marginTop: 0, marginBottom: '20px', color: '#fff' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column' },
  label: { marginBottom: '8px', color: '#bbb', fontWeight: 'bold', fontSize: '14px' },
  input: {
    padding: '12px', fontSize: '16px', border: '1px solid #555',
    borderRadius: '6px', outline: 'none', backgroundColor: '#1a1a1a', color: '#fff'
  },
  error: {
    padding: '12px', backgroundColor: '#dc3545', color: '#fff',
    borderRadius: '6px', fontSize: '14px', textAlign: 'center'
  },
  modalActions: { display: 'flex', gap: '10px', marginTop: '10px' },
  saveButton: {
    flex: 1, padding: '12px', backgroundColor: '#28a745', color: 'white',
    border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold'
  },
  cancelButton: {
    flex: 1, padding: '12px', backgroundColor: '#6c757d', color: 'white',
    border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold'
  }
};

export default UserManagement;